import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input,
  OnInit
} from '@angular/core';

import {
  HaynesProElectronicLocationGroupModel,
  HaynesProElectronicLocationItemModel,
  HaynesProElectronicLocationSystemModel
} from '../../../typings/haynes-pro.diagnostic-tool.electronic-location-details';

import { HaynesProService } from '../../../haynes-pro.service';
import { VehicleModel }     from '../../../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-vesa-component-location',
  styles: [ require('./haynes-pro.diagnostic-tool.vesa-component-location.component.scss') ],
  template: require('./haynes-pro.diagnostic-tool.vesa-component-location.component.html')
})
export class HaynesProDiagnosticToolVesaComponentLocationComponent implements OnInit {

  @Input() componentCode : string;
  @Input() componentName : string;
  @Input() vehicle       : VehicleModel;

  isLoading          = true;
  highlightLocation  = '';
  selectedIndex      = 0;

  location       : HaynesProElectronicLocationSystemModel                                       = null;
  matchedSystems : Array<{ system: HaynesProElectronicLocationSystemModel; groupName: string }> = [];

  constructor (
    private cdr              : ChangeDetectorRef,
    @Inject(forwardRef(() => HaynesProService))
    private haynesProService : HaynesProService
  ) {}

  ngOnInit () : void {
    this.haynesProService.getLocationsBySubject(this.vehicle)
    .then(( groups : Array<HaynesProElectronicLocationGroupModel> ) => {
      this.findMatchingSystems(groups);
    })
    .finally(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    });
  }

  selectSystem ( index : number ) : void {
    if (index === this.selectedIndex) {
      return;
    }

    this.location          = null;
    this.selectedIndex     = index;
    this.highlightLocation = '';

    // delay for electronic-location-details to re-initialise with new location
    setTimeout(() => {
      this.location          = this.matchedSystems[index]?.system || null;
      this.highlightLocation = this.componentCode;
      this.cdr.detectChanges();
    });
  }

  private findMatchingSystems ( groups : Array<HaynesProElectronicLocationGroupModel> ) : void {
    if (!groups || !this.componentCode) {
      return;
    }

    const code = this.componentCode.toUpperCase();
    const name = (this.componentName || '').toUpperCase();

    for (const group of groups) {
      if (!group.location_systems) {
        continue;
      }

      const groupDesc = (group.description || '').toUpperCase();

      for (const system of group.location_systems) {
        const hasItemMatch  = (system.items || [])
                                .some(( item : HaynesProElectronicLocationItemModel ) => item.location?.toUpperCase() === code);
        const hasGroupMatch = !hasItemMatch && !!name && groupDesc === name;

        if (hasItemMatch || hasGroupMatch) {
          this.matchedSystems.push({
            system   : system,
            groupName: group.description
          });
        }
      }
    }

    if (this.matchedSystems.length) {
      this.location          = this.matchedSystems[0].system;
      this.highlightLocation = this.componentCode;
    }
  }
}
